module.exports = __webpack_public_path__ + "5342ac09313896ff8302f497eb3144d7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/flask-green-s.png
// module id = 2520
// module chunks = 0